import { render, staticRenderFns } from "./YqxViewer.vue?vue&type=template&id=4537be04"
import script from "./YqxViewer.vue?vue&type=script&lang=js"
export * from "./YqxViewer.vue?vue&type=script&lang=js"
import style0 from "./YqxViewer.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports